import IframeActivity from "./IframeActivity";

export default function BeatProcrastination() {
    return (
        <IframeActivity
            src="/activities/beat-procrastination/index.html"
            title="Beat Procrastination"
        />
    );
}